import styled from 'styled-components';

interface ISvgPath {
    animate: boolean;
    disabled: boolean;
}

export const SCSvgWrapper = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    width: 25px;
    height: 25px;
    overflow: hidden;
    background-color: #f5f6f7;
`;

export const SCSvgRoot = styled.svg`
    fill-rule: evenodd;
    clip-rule: evenodd;
    stroke-linejoin: round;
    stroke-miterlimit: 2;
`;

export const SCSvgPath = styled.path<ISvgPath>`
    fill: ${(props): string =>
        props.animate === true
            ? props.disabled
                ? `rgba(255, 255, 255, 0.5)`
                : `rgba(255, 255, 255, 1)`
            : props.disabled
            ? `rgba(100, 100, 104, 0.5)`
            : `rgba(100, 100, 104, 1)`};
    transition: fill 0.25s ease-out;
`;
